export const EMBEDDED_BOOKING_CLOSE_MESSAGE = 'scheduify:booking-close';

export type EmbeddedBookingCloseMessage = {
  type: typeof EMBEDDED_BOOKING_CLOSE_MESSAGE;
  tenantId: string;
};

type EmbeddedBookingWindow = Pick<Window, 'location'> & {
  parent: Pick<Window, 'postMessage'> | Window;
};

export const createEmbeddedBookingCloseMessage = (
  tenantId: string
): EmbeddedBookingCloseMessage => ({
  type: EMBEDDED_BOOKING_CLOSE_MESSAGE,
  tenantId,
});

export const requestEmbeddedBookingClose = (
  tenantId: string,
  sourceWindow: EmbeddedBookingWindow = window
): boolean => {
  if (sourceWindow.parent === sourceWindow) {
    return false;
  }
  sourceWindow.parent.postMessage(
    createEmbeddedBookingCloseMessage(tenantId),
    sourceWindow.location.origin
  );
  return true;
};
